import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import dayjs from 'dayjs';

export const useStartDueDateFields = ({
  id,
  timezone,
  startsAtName = 'startsAt',
  dueAtName = 'dueAt',
}) => {
  const { watch } = useFormContext();
  const adjustToTimezone = useCallback(
    (val) => (dayjs(val).isValid() ? dayjs(val).utc(false).tz(timezone) : null),
    [timezone],
  );
  const cachedStartsAt = adjustToTimezone(watch(`${id}.${startsAtName}`));
  const cachedDueAt = adjustToTimezone(watch(`${id}.${dueAtName}`));

  const humanReadableFormat = 'YYYY-MM-DD hh:mm:ss A';
  const formatedStartsAt =
    cachedStartsAt && cachedStartsAt.format(humanReadableFormat);
  const formatedDueAt = cachedDueAt && cachedDueAt.format(humanReadableFormat);

  const currentDate = dayjs().utc(false).tz(timezone);
  const startDateIsInTheFuture = cachedStartsAt
    ? cachedStartsAt.isAfter(currentDate, 'date')
    : false;

  const startDateMaxDate = cachedDueAt || currentDate.add(1, 'year');
  const startDateMinDate = currentDate;

  const dueAtMinDate = startDateIsInTheFuture ? cachedStartsAt : currentDate;
  return {
    startDateMaxDate,
    startDateMinDate,
    formatedStartsAt,
    dueAtMinDate,
    formatedDueAt,
    cachedDueAt,
    cachedStartsAt,
  };
};
